import React from "react";
import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";
import { connect } from "react-redux";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import "./WebEditArticleImageList.css";
import { toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import { getPageImagesApi } from "../../api/pages";
import UploadPageImageModal from "../UploadPageImageModal/UploadPageImageModal";
import RotateModal from "../RotateModal/RotateModal";
import CombineImageModal from "../CombineImageModal/CombineImageModal";
import { sendImageRequestAction } from "../../redux/actions/editArticlePanel";

class WebEditArticleImageList extends React.Component {
  constructor(props) {
    super(props);
    this.loadPages = this.loadPages.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.imageClicked = this.imageClicked.bind(this);
    this.imageRotateClicked = this.imageRotateClicked.bind(this);
    this.imageMergeClicked = this.imageMergeClicked.bind(this);
    this.handleCombineSwitch = this.handleCombineSwitch.bind(this);
    this.state = {
      imgs: null,
      showAddImage: false,
      showRotateImageID: null,
      showMergeLeftImageID: null,
      showMergeRightImageID: null
    };
  }

  handleCloseModal(reload) {
    if (reload) {
      this.loadPages();
    }

    this.setState({
      showAddImage: false,
      showRotateImageID: null,
      showMergeLeftImageID: null,
      showMergeRightImageID: null
    });
  }

  imageRotateClicked(imageID) {
    this.setState({
      showRotateImageID: imageID
    });
  }

  handleCombineSwitch() {
    const { showMergeLeftImageID, showMergeRightImageID } = this.state;

    this.setState({
      showMergeLeftImageID: showMergeRightImageID,
      showMergeRightImageID: showMergeLeftImageID
    });
  }

  imageMergeClicked(imageID) {
    const { showMergeLeftImageID, showMergeRightImageID } = this.state;

    if (imageID === showMergeLeftImageID) {
      this.setState({ showMergeLeftImageID: null });
      return;
    }

    if (imageID === showMergeRightImageID) {
      this.setState({ showMergeRightImageID: null });
      return;
    }

    if (showMergeLeftImageID == null && showMergeRightImageID == null) {
      this.setState({ showMergeLeftImageID: imageID });
    } else if (showMergeLeftImageID != null && showMergeRightImageID == null) {
      this.setState({ showMergeRightImageID: imageID });
    } else if (showMergeLeftImageID != null && showMergeRightImageID != null) {
      this.setState({
        showMergeLeftImageID: showMergeRightImageID,
        showMergeRightImageID: imageID
      });
    } else {
      this.setState({ showMergeRightImageID: imageID });
    }
  }

  imageClicked(image) {
    const { issue } = this.props;
    const issueID = issue.id;

    this.props.sendImageRequestAction(image, issueID, toast);
  }

  componentDidMount() {
    this.loadPages();
  }

  componentDidUpdate(prevProps) {
    const { article } = this.props;

    if (prevProps.article == null || article.id !== prevProps.article.id) {
      this.loadPages();
    }
  }

  async loadPages() {
    this.setState({ imgs: null });

    const { article } = this.props;
    const { pages } = article;

    let pageNumToProcess = [0];

    let promiseArr = pageNumToProcess.map(aPageNum => {
      const pageID = pages[aPageNum].id;
      return getPageImagesApi(pageID);
    });

    let returnArr = [];
    let idArr = [];

    try {
      const result = await Promise.all(promiseArr).catch(e => {
        throw e;
      });

      for (let i = 0; i < result.length; i++) {
        for (let j = 0; j < result[i].length; j++) {
          if (idArr.indexOf(result[i][j].id) < 0) {
            const item = result[i][j];
            item.imageUri = `${process.env.REACT_APP_API_ROOT}artworks/${
              item.id
            }/static/thumbnail`;

            idArr.push(item.id);
            returnArr.push(item);
          }
        }
      }

      this.setState({
        imgs: returnArr
      });
    } catch (e) {
      toast.error(e.toString());
    }
  }

  render() {
    const { imgs } = this.state;

    const { article } = this.props;
    const { pages } = article;

    let pageID = pages[0].id;

    const isLoading = imgs == null;

    const { showMergeLeftImageID, showMergeRightImageID } = this.state;

    let chunkArray = [];

    if (!isLoading) {
      for (let i = 0; i < imgs.length; i += 3) {
        let aChunk = imgs.slice(i, i + 3);
        chunkArray.push(aChunk);
      }
    }

    return (
      <Container className="pdf_thumb_image_container">
        <Row>
          <Col>
            <Button
              disabled={isLoading}
              className="article_add_image_btn"
              variant="warning"
              title="Add"
              onClick={() => this.setState({ showAddImage: true })}
              style={{ display: "inline" }}
            >
              Upload
            </Button>
          </Col>
        </Row>

        {isLoading && (
          <div className="article_spinner_container">
            <Spinner animation="grow" />
          </div>
        )}

        {!isLoading &&
          chunkArray.map((aChunk, idx) => {
            return (
              <Row className="pdf_thumb_image" key={idx}>
                {aChunk.map(anImage => {
                  const imageUri = anImage.imageUri;
                  return (
                    <Col key={anImage.id} xs="4" sm="4" md="4" lg="3" xl="2">
                      <div className="image_thumb_container">
                        <Image
                          src={imageUri}
                          thumbnail
                          onClick={() => this.imageClicked(anImage)}
                        />
                        <Button
                          className="select_rotate_btn"
                          variant="primary"
                          size="sm"
                          onClick={() => this.imageRotateClicked(anImage.id)}
                        >
                          <span className="fa fa-undo" />
                        </Button>
                        <Button
                          className="select_merge_btn"
                          variant={
                            anImage.id === showMergeLeftImageID ||
                            anImage.id === showMergeRightImageID
                              ? "warning"
                              : "info"
                          }
                          size="sm"
                          onClick={() => this.imageMergeClicked(anImage.id)}
                        >
                          <span className="fa fa-qrcode" />
                        </Button>
                      </div>
                      <div className="image_thumb_size">
                        {anImage.width} x {anImage.height}
                      </div>
                    </Col>
                  );
                })}
              </Row>
            );
          })}

        {pageID && this.state.showAddImage && (
          <UploadPageImageModal
            pageID={pageID}
            showCreateModal={this.state.showAddImage}
            handleCloseModal={this.handleCloseModal}
          />
        )}
        {pageID && this.state.showRotateImageID && (
          <RotateModal
            pageID={pageID}
            imageID={this.state.showRotateImageID}
            showCreateModal={this.state.showRotateImageID != null}
            handleCloseModal={this.handleCloseModal}
          />
        )}
        {pageID &&
          this.state.showMergeLeftImageID != null &&
          this.state.showMergeRightImageID != null && (
            <CombineImageModal
              pageID={pageID}
              leftImageID={this.state.showMergeLeftImageID}
              rightImageID={this.state.showMergeRightImageID}
              showCreateModal={
                this.state.showMergeLeftImageID != null &&
                this.state.showMergeRightImageID != null
              }
              handleCloseModal={this.handleCloseModal}
              handleCombineSwitch={this.handleCombineSwitch}
            />
          )}
      </Container>
    );
  }
}

const mapDispatch = {
  sendImageRequestAction
};

export default connect(
  null,
  mapDispatch
)(WebEditArticleImageList);
